module.exports = __webpack_public_path__ + "img/Geburtstagsparty.a6d8fd07.svg";